import dayjs from 'dayjs'
import type { Recurrence } from 'src/v3/core/types'

/**
 * Calculates the number of days between go-live and due dates
 */
export let calculateDueDaysAfterGoLive = (
  goLiveDate: string,
  dueDate: string,
): number => dayjs(dueDate).diff(dayjs(goLiveDate), 'day')

/**
 * Normalizes recurrence data by ensuring recurrenceEndDate is undefined if empty
 */
export let normalizeRecurrence = (
  recurrence?: Recurrence,
): Recurrence | undefined => {
  if (!recurrence) {
    return undefined
  }

  return {
    ...recurrence,
    recurrenceEndDate: recurrence.recurrenceEndDate || undefined,
  }
}

/**
 * Checks if a schedule status is terminal (Complete or Cancelled)
 */
export let isScheduleTerminated = (
  status: 'Pending' | 'Activated' | 'Cancelled' | 'Complete',
): boolean => status === 'Complete' || status === 'Cancelled'
